<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <!-- <v-row> -->


      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.push({ name: 'Home' })"
        >
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br/><br/>
        <div
              class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text"
            >{{ title }}</div>
        <v-row align="center">
          <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
          <InputCustom :inputProp="inputPassword" />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
          <InputCustom :inputProp="inputPasswordNew" />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
          <InputCustom :inputProp="inputPasswordConfirm" />
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="12" xs="12" sm="12" md="2" lg="6" xl="6">
          <v-btn
            color="success"
            elevation="7"
            large
            v-on:click="examen = true"
            @click="updatePassword()"
            >Cambiar contraseña</v-btn
          >
          </v-col>
        </v-row>
          

      </v-col>

      <!-- </v-row> -->
    </CardIeaAppMain>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";
import InputCustom from "../../components/InputCustom";
import MessagesRules from "../../config/MessagesRules";
export default {
  name: "MateriaCodigoClaseVideo",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
    InputCustom
  },

  data: () => ({
    title:"Cambiar contraseña",
    inputPassword: 
      {
        tag: "email",
        text: "Contraseña actual",
        placeholder: "Escribe tu contraseña actual",
        icon: "mdi-form-textbox-password",
        required: true,
        value: "",
        type: "password",
        rules: [
          v => !!v || "Contraseña actual" + MessagesRules.required,
        ],
        counter: 0
      },
      inputPasswordNew: 
      {
        tag: "email",
        text: "Contraseña nueva",
        placeholder: "Escribe tu nueva contraseña",
        icon: "mdi-form-textbox-password",
        required: true,
        value: "",
        type: "password",
        rules: [
          v => !!v || "Contraseña nueva" + MessagesRules.required,
        ],
        counter: 0
      },
      inputPasswordConfirm: 
      {
        tag: "email",
        text: "Confirma nueva contraseña",
        placeholder: "Repite tu nueva contraseña",
        icon: "mdi-form-textbox-password",
        required: true,
        value: "",
        type: "password",
        rules: [
          v => !!v || "Confirmación de contraseña " + MessagesRules.required,
        ],
        counter: 0
      },
      
  }),
  methods: {

    async updatePassword() {
      // base de datos aceptado feedback
      let currentPassword =  this.inputPassword.value ;
      let newPassword =  this.inputPasswordNew.value ;
      let confirmPasword =  this.inputPasswordConfirm.value ;

      if (currentPassword == "" && newPassword == "" && confirmPasword == "") {
        alert("Debe llenar todos los campos");
        return;
      }
      if (newPassword !== confirmPasword) {
        alert("No coincide las contraseña nueva con la confirmación");
        return;
      }

      let dataSend = {
        currentPassword: currentPassword,
        newPassword: newPassword,
        confirmPasword: confirmPasword
      };
      let url = "alumno/changePassword";
     
      await this.$API
        .post({
          url: url,
          data: dataSend
        })
        .then(() => {
          this.$router.push({
            name: 'Home'
          });  
          
        });
    }
  }
};
</script>
